import moment from 'moment';

export default {
  details: [
    {
      name: 'ownershipType',
      label: '160 Owned or Leased',
      component: 'viewOnly'
    },
    {
      name: 'inspectionDate',
      label: 'Date',
      component: 'viewOnly',
      format: value => (value ? moment(value).parseZone().format('MM/DD/YYYY') : '')
    },
    {
      name: 'yardName',
      label: 'Location',
      component: 'viewOnly'
    },
    {
      name: 'inspectionType',
      label: 'Inspection Type',
      component: 'viewOnly'
    },
    { name: 'odometerReading', label: 'Odometer Reading', component: 'input' }
  ],
  noDefects: [{ name: 'noDefects', label: 'No defects noted', component: 'checkbox' }],
  driver: [
    { name: 'remarks', label: 'Remarks', component: 'textarea', props: { rows: 3 } },
    {
      name: 'conditionStatus',
      label: '',
      component: 'radio',
      inlineLabelRows: true,
      options: [
        { label: 'Condition of the above vehicle is satisfactory.', id: 'satisfactory' },
        {
          label: 'Condition of the above vehicle is NOT satisfactory. (Out of Service/Red Tag)',
          id: 'not_satisfactory',
          disabled: true
        }
      ]
    },
    { name: 'driverName', label: 'Driver Name', component: 'input' },
    { name: 'signatureData', label: 'Driver Signature', component: 'signaturePad' }
  ]
};
